import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    refurbishDeviceRequest,
    clearRedux,
} from 'Redux/actions';

const VIDFLEET_ERROR_CODES = {
    23: "common_authentication_failed",
    24: "",
    200: "common_camera_password_error",
    201: "common_camera_operation_failed",
    202: "common_camera_does_not_exist",
    204: "common_sync_camera_error",
    209: "common_camera_does_not_exist",
}

const FormatSDCard = (props) => {
    const { device } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { loading, openModal, result } = useSelector(state => state.refurbishDeviceRedux);

    const closeModal = () => {
        dispatch(clearRedux("REFURBISH_DEVICE"));
    }

    const confirmFormat = () => {
        dispatch(refurbishDeviceRequest({ esn: device?.esn, id: device?.id }));
    }

    useEffect(() => {
        if (result && !result?.error) {
            NotificationManager.success(
                messages['refurbish_device_command_sent_to_the_device'],
                messages['refurbish_device_title'],
                3000
            );
            closeModal();

            if (props.getDevice)
                props.getDevice();
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['refurbish_device_title']}
            loading={loading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <label style={{ marginBottom: 5 }}>
                        {messages['refurbish_device_label']}
                    </label>
                </div>
                <div style={{ padding: '0 10px' }}>
                    <label style={{ marginTop: 5, display: "flex" }}>
                        <p style={{ fontWeight: "bold", marginRight:5 }}>{messages['refurbish_device_esn']}:</p> {device?.esn}
                    </label>
                </div>
                <div style={{ padding: '0 10px' }}>
                    <label style={{ marginTop: 5, display: "flex" }}>
                        <p style={{ fontWeight: "bold", marginRight:5 }}>{messages['refurbish_device_imei']}:</p> {device?.imei}
                    </label>
                </div>
                <div style={{ padding: '0 10px' }}>
                    <label style={{ marginTop: 5, display: "flex" }}>
                        <p style={{ fontWeight: "bold", marginRight:5 }}>{messages['refurbish_device_sim_provider_account']}:</p> {device?.simCard?.simProviderAccount?.name} {device?.simCard?.simProviderAccount?.simProvider?.name ? `- ${device?.simCard?.simProviderAccount?.simProvider?.name}` : ""}
                    </label>
                </div>
                <div style={{ padding: '0 10px' }}>
                    <label style={{ marginTop: 5, display: "flex" }}>
                        <p style={{ fontWeight: "bold", marginRight:5 }}>{messages['refurbish_device_sim_number']}:</p> {device?.iccid}
                    </label>
                </div>
                <div style={{ padding: '0 10px' }}>
                    <label style={{ marginTop: 5, display: "flex" }}>
                        <p style={{ fontWeight: "bold", marginRight:5 }}>{messages['refurbish_device_phone_number']}:</p> {device?.msisdn}
                    </label>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => confirmFormat()}
                >
                    {messages['refurbish_device_refurbish']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default FormatSDCard;